import { Tag, TagAppliesToType } from "./Tag";
import { Translation } from "./Translation";
import { v4 as uuidv4 } from "uuid";

export class TagAssociation {
  private constructor(
    readonly id: string,
    readonly ticker: string,
    readonly translations: Translation[],
    readonly type: TagAppliesToType,
    readonly tags: Tag[]
  ) {}

  static of(
    ticker: string,
    translations: Translation[],
    type: TagAppliesToType,
    tags: Tag[] = [],
    id: string | undefined = undefined
  ): TagAssociation {
    return new TagAssociation(id ?? uuidv4(), ticker, translations, type, tags);
  }

  getTitle(locale: string): string {
    const shortLocale = locale.includes("-") ? locale.split("-")[0] : locale;
    const translation = this.translations.find(t => t.locale === shortLocale);
    if (translation) {
      return translation.translation;
    }

    return this.translations.length > 0 ? this.translations[0].translation : this.ticker;
  }
}
